import Module from '../../module';
import scroll from '../../../libs/scroll/scroll';

interface OptionsInterface {
	cssId: {
		anim?: {
			investorsEsgInfoContentSectionCls: string;
		}
	},

	slug: string
}

class Info extends Module {

	publicVars: OptionsInterface;

	constructor(options: OptionsInterface) {
		super('Investors ESG Info Module');

		this.publicVars = options;
	}

	startup() {
		this.msg('startup');

		scroll.init();
		scroll.registerAnimatedElement(this.publicVars.cssId.anim?.investorsEsgInfoContentSectionCls || '', 'investors_esg_info', { animCls: 'animate__fadeIn', once: true});
	}

	bind() {
		this.msg('bind');
	}
}

export default Info;